/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  PluginDefinitionResponse,
  PluginMappingConfigResponse,
  PluginMappingResponse,
  PluginType,
  UpsertPluginMappingRequest,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    PluginDefinitionResponseFromJSON,
    PluginDefinitionResponseToJSON,
    PluginMappingConfigResponseFromJSON,
    PluginMappingConfigResponseToJSON,
    PluginMappingResponseFromJSON,
    PluginMappingResponseToJSON,
    PluginTypeFromJSON,
    PluginTypeToJSON,
    UpsertPluginMappingRequestFromJSON,
    UpsertPluginMappingRequestToJSON,
} from '../models/index';

export interface GetPluginMappingConfigRequest {
    type: PluginType;
    customerId: string;
    refId?: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface GetPluginMetadataSchemaRequest {
    type: PluginType;
    customerId: string;
    refId?: string;
    promotionTrigger?: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface GetPluginSchemaRequest {
    pluginId: string;
    customerId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface ListPluginDefinitionsRequest {
    customerId: string;
    type?: PluginType;
    xClientID?: string;
    xRequestID?: string;
}

export interface ListPluginMappingsRequest {
    customerId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface UpsertPluginMappingOperationRequest {
    type: PluginType;
    customerId: string;
    upsertPluginMappingRequest: UpsertPluginMappingRequest;
    xClientID?: string;
    xRequestID?: string;
}

/**
 * 
 */
export class PluginConfigurationApi extends runtime.BaseAPI {

    /**
     */
    async getPluginMappingConfigRaw(requestParameters: GetPluginMappingConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PluginMappingConfigResponse>> {
        if (requestParameters['type'] == null) {
            throw new runtime.RequiredError(
                'type',
                'Required parameter "type" was null or undefined when calling getPluginMappingConfig().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getPluginMappingConfig().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refId'] != null) {
            queryParameters['refId'] = requestParameters['refId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:plugins"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/plugins/mappings/{type}`;
        urlPath = urlPath.replace(`{${"type"}}`, encodeURIComponent(String(requestParameters['type'])));
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PluginMappingConfigResponseFromJSON(jsonValue));
    }

    /**
     */
    async getPluginMappingConfig(requestParameters: GetPluginMappingConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PluginMappingConfigResponse> {
        const response = await this.getPluginMappingConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getPluginMetadataSchemaRaw(requestParameters: GetPluginMetadataSchemaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['type'] == null) {
            throw new runtime.RequiredError(
                'type',
                'Required parameter "type" was null or undefined when calling getPluginMetadataSchema().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getPluginMetadataSchema().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refId'] != null) {
            queryParameters['refId'] = requestParameters['refId'];
        }

        if (requestParameters['promotionTrigger'] != null) {
            queryParameters['promotionTrigger'] = requestParameters['promotionTrigger'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:plugins"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/plugins/{type}/metadata-schema`;
        urlPath = urlPath.replace(`{${"type"}}`, encodeURIComponent(String(requestParameters['type'])));
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getPluginMetadataSchema(requestParameters: GetPluginMetadataSchemaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getPluginMetadataSchemaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getPluginSchemaRaw(requestParameters: GetPluginSchemaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['pluginId'] == null) {
            throw new runtime.RequiredError(
                'pluginId',
                'Required parameter "pluginId" was null or undefined when calling getPluginSchema().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getPluginSchema().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:plugins"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/plugins/definitions/{pluginId}/schema`;
        urlPath = urlPath.replace(`{${"pluginId"}}`, encodeURIComponent(String(requestParameters['pluginId'])));
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getPluginSchema(requestParameters: GetPluginSchemaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getPluginSchemaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async listPluginDefinitionsRaw(requestParameters: ListPluginDefinitionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PluginDefinitionResponse>>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling listPluginDefinitions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:plugins"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/plugins/definitions`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PluginDefinitionResponseFromJSON));
    }

    /**
     */
    async listPluginDefinitions(requestParameters: ListPluginDefinitionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PluginDefinitionResponse>> {
        const response = await this.listPluginDefinitionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async listPluginMappingsRaw(requestParameters: ListPluginMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PluginMappingResponse>>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling listPluginMappings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:plugins"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/plugins/mappings`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PluginMappingResponseFromJSON));
    }

    /**
     */
    async listPluginMappings(requestParameters: ListPluginMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PluginMappingResponse>> {
        const response = await this.listPluginMappingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async upsertPluginMappingRaw(requestParameters: UpsertPluginMappingOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PluginMappingResponse>> {
        if (requestParameters['type'] == null) {
            throw new runtime.RequiredError(
                'type',
                'Required parameter "type" was null or undefined when calling upsertPluginMapping().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling upsertPluginMapping().'
            );
        }

        if (requestParameters['upsertPluginMappingRequest'] == null) {
            throw new runtime.RequiredError(
                'upsertPluginMappingRequest',
                'Required parameter "upsertPluginMappingRequest" was null or undefined when calling upsertPluginMapping().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:plugins"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/plugins/mappings/{type}`;
        urlPath = urlPath.replace(`{${"type"}}`, encodeURIComponent(String(requestParameters['type'])));
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpsertPluginMappingRequestToJSON(requestParameters['upsertPluginMappingRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PluginMappingResponseFromJSON(jsonValue));
    }

    /**
     */
    async upsertPluginMapping(requestParameters: UpsertPluginMappingOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PluginMappingResponse> {
        const response = await this.upsertPluginMappingRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
